export function resolveApiMessage(error, t, fallbackKey, fallbackMessage) {
  const key = error?.response?.data?.message_key;
  const message = error?.response?.data?.message;
  const params = error?.response?.data?.params;
  if (key) {
    const interpolation = params && typeof params === "object" ? params : {};
    return t(key, { ...interpolation, defaultValue: message || t(fallbackKey || key) });
  }
  if (fallbackKey) {
    return t(fallbackKey, { defaultValue: message || fallbackMessage });
  }
  return message || fallbackMessage || t("errors.generic");
}
